// React imports.
import React from "react";

import { Assessment1StepsEnum } from "../state";
import { Assessment1FuelStatusEnum } from "../state";


const Assessment1QuestionsOverReporting = ({fuelType, state, showDontKnowNote }) => (
    <div>
        <ol>
            <li>
                One or more of the vendors are including optional charges (e.g. deposits or service contracts)
                in the expenditure amounts they report to you. If that occurred,  you will need to ask the
                vendor to supply the expenditure amounts for their LIHEAP households without any optional
                charges included.
                <br/><br/>
            </li>
            <li>
                One or more of the vendors reported data for a period greater than 12 months. If that
                occurred, you would need to ask them to report information for a 12-month period only.
                <br/><br/>
            </li>
            <li>
                One or more of the vendors have included outliers caused by errors in the data they
                report to you. For example, sometimes when a household owns a farm, the vendor reports
                the farm account rather than the household account. If errors like this occurred,
                you will need to have your IT department identify the outliers and contact the vendor
                to confirm the true expenditure amounts for the households in question.
                <br/><br/>
            </li>
            <li>
                One or more of your vendors reported the total amount owed (including arrearages) by
                each household each month rather than the amount that each household was billed. If
                this occurred, you will need to ask the vendor to supply expenditure amounts that
                include only the new amount that each household was billed each month without the
                inclusion of any arrearages or other overdue charges.
                <br/><br/>
            </li>
        </ol>

        Let’s walk through each of these issues so that you can assess whether any of them might be a problem for your data.&nbsp;
        {showDontKnowNote === true
          &&<span>
                Please answer each of the questions below. Depending on your response, each question
                may ask you to outline an action item to help you address the issue.
                <br/><br/>
                <strong>
                    If you don't know the answer to a question please indicate "No/Don't Know"
                    and provide your plans to acquire this information from IT department or
                    programming staff in the response box.
                </strong>
            </span>}
        <br/><br/>

        <ol>
            {/*OPTIONAL*/}
            <li>
                Do your {fuelType.description}&nbsp;vendors indicate they are excluding optional charges (e.g. deposits or
                servicing contracts) in the expenditure amounts they report to you?<br/>
                <label>
                    <input type="radio"
                        name="IncludingEnergyOptionalChargesFlag"
                        id="IncludingEnergyOptionalChargesFlag_true"
                        value="false"
                        checked={fuelType.IncludingEnergyOptionalChargesFlag === false}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludingEnergyOptionalChargesFlag"
                        id="IncludingEnergyOptionalChargesFlag_false"
                        value="true"
                        checked={fuelType.IncludingEnergyOptionalChargesFlag === true}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No / Don't Know</span>
                </label>
                <br/ >
                {fuelType.IncludingEnergyOptionalChargesFlag === false
                  && <span><strong>No action needed</strong></span>}
                {fuelType.IncludingEnergyOptionalChargesFlag === true
                  &&
                    <span>
                      <strong>Requires followup.</strong>&nbsp;
                      The expenditure amounts reported by your {fuelType.description}&nbsp;vendors should NOT include optional charges.
                      If your vendors are including this information in their final report it will cause your average
                      &nbsp;{fuelType.description}&nbsp; expenditures to be incorrectly inflated.
                      <br/><br/>
                      Please indicate your plans to address this issue in the box below
                      <textarea  name="IncludingEnergyOptionalChargesDesc"
                          id="IncludingEnergyOptionalChargesDesc" style={{width:"100%"}}
                          value={fuelType.IncludingEnergyOptionalChargesDesc}
                          onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>

            {/*12 MONTH ONLY*/}
            <li>
                Do your {fuelType.description}&nbsp;vendors indicate they are including the total amount for a 12-month period only?
                <br/>
                <label>
                    <input type="radio"
                        name="Including12MonthOnlyFlag"
                        id="Including12MonthOnlyFlag_true"
                        value="true"
                        checked={fuelType.Including12MonthOnlyFlag === true}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="Including12MonthOnlyFlag"
                        id="Including12MonthOnlyFlag_false"
                        value="false"
                        checked={fuelType.Including12MonthOnlyFlag === false}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No / Don't Know</span>
                </label>
                <br/ >
                {fuelType.Including12MonthOnlyFlag === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.Including12MonthOnlyFlag === false
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        Vendors should be reporting for a 12 month period only. If your vendors are reporting for
                        more than 12 months, this will cause your average &nbsp;{fuelType.description}&nbsp;
                        expenditures to be incorrectly inflated.
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="Including12MonthOnlyDesc"
                            id="Including12MonthOnlyDesc" style={{width:"100%"}}
                            value={fuelType.Including12MonthOnlyDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>

            {/*OUTLIERS*/}
            <li>
                Do your  {fuelType.description}  vendors check outliers in the data they report to you to ensure that they did not make any errors?
                <br/>
                <label>
                    <input type="radio"
                        name="CheckOutliersFlag"
                        id="CheckOutliersFlag_true"
                        value="true"
                        checked={fuelType.CheckOutliersFlag === true}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="CheckOutliersFlag"
                        id="CheckOutliersFlag_false"
                        value="false"
                        checked={fuelType.CheckOutliersFlag === false}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No / Don't Know</span>
                </label>
                <br/ >
                {fuelType.CheckOutliersFlag === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.CheckOutliersFlag === false
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        Vendors should be checking the data they provide for outliers because sometimes these outliers are
                        present due to vendor error. For example, sometimes when the household owns a farm, the vendor
                        reports the farm account rather than the household account. If instances such as those appear
                        in the data your vendors are providing then your average expenditure numbers are likely to be
                        incorrectly inflated.   
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="CheckOutliersDesc"
                            id="CheckOutliersDesc" style={{width:"100%"}}
                            value={fuelType.CheckOutliersDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>

            {/*ONLYAMTBILLED*/}  
            <li>
                Do your {fuelType.description}  vendors indicate they are only including the new amounts that households are billed each month,
                and not the total amount owed (including any arrearages or overdue charges) in the expenditure amounts they report to you?
                <br/>
                <label>
                    <input type="radio"
                        name="IncludeOnlyAmountBilledFlag"
                        id="IncludeOnlyAmountBilledFlag_true"
                        value="true"
                        checked={fuelType.IncludeOnlyAmountBilledFlag === true}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludeOnlyAmountBilledFlag"
                        id="IncludeOnlyAmountBilledFlag_false"
                        value="false"
                        checked={fuelType.IncludeOnlyAmountBilledFlag === false}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No / Don't Know</span>
                </label>
                <br/ >
                {fuelType.IncludeOnlyAmountBilledFlag === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.IncludeOnlyAmountBilledFlag === false
                  &&<span><strong>Requires followup.</strong>&nbsp;
                        Vendors should be reporting the new billing amount for each household each month and should
                        NOT be including any outstanding or overdue charges that might cause the total amount owed
                        to be higher than that of the billing amount. If vendors are including arrearages or other
                        outstanding charges in the expenditure amounts they report for each household this will
                        cause your average expenditure amounts to be incorrectly inflated.

                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="IncludeOnlyAmountBilledDesc"
                            id="IncludeOnlyAmountBilledDesc" style={{width:"100%"}}
                            value={fuelType.IncludeOnlyAmountBilledDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>

            {(state.assessment1ShowCatchallQuestionOver(fuelType) === true && showDontKnowNote === true)
            &&
                <div>
                    It appears that your potential data reliability issue cannot be
                    explained by the most common reasons we have found
                    for why states' estimates differ from the SEDS.
                    Please contact APPRISE to discuss other potential
                    explanations for this discrepancy. If you have any
                    ideas about what might be causing the discrepancy
                    please document it in the response box below.                        
                    <textarea  name="OtherReasonDesc"
                        id="OtherReasonDesc" style={{width:"100%"}}
                        value={fuelType.OtherReasonDesc}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                </div>
            }
        </ol>
    </div>
);

export default Assessment1QuestionsOverReporting;
